/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Component, Input, OnChanges, OnInit, ViewChild} from "@angular/core";
import {ServiceService} from "../../services/service.service";
import {ServerObjectService} from "../../services/server-object.service";
import {NgxSpinnerService} from "ngx-spinner";
import { ERROR_DIALOG_TITLE, SimpleSuccessErrorDialogComponent } from "../simple-success-error-dialog-box/simple-success-error-dialog-box.component";

declare var $: any;

@Component({
  selector: 'app-settings-mapping',
  templateUrl: './settings.mapping.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsMappingComponent implements OnInit, OnChanges {

    /** Reference to the SimpleSuccessErrorDialog used to display error */
  @ViewChild('successErrorDialog') 
  simpleSuccessErrorDialogComponent: SimpleSuccessErrorDialogComponent;

  @Input() mapping;
  serverObjectInstance = null;

  assets: boolean;
  people: boolean;
  breadcrumbs: boolean;
  perimeters: boolean;
  zones: boolean;
  zoneNames: boolean;
  sublocations: boolean;
  sublocationNames: boolean;

  constructor(private services: ServiceService, private serverObjectService: ServerObjectService, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    console.log("Mapping started");
  }

  ngOnChanges(): void {
    if (this.mapping) {
      // Found the email service
      console.log("mapping id is " + this.mapping.id);

      this.serverObjectService.getServerObjectInstanceById(this.mapping.id).then(response => {
          this.serverObjectInstance = response;
          this.setLocateSettings();
        },
        error => {
          this.handleError(error);
        });
    }
  }

  assetsClicked(): void {
    this.assets = $("#assets")[0].checked
  }

  peopleClicked(): void {
    this.people = $("#people")[0].checked
  }

  perimetersClicked(): void {
    this.perimeters = $("#perimeters")[0].checked
  }

  breadcrumbsClicked(): void {
    this.breadcrumbs = $("#breadcrumbs")[0].checked
  }

  zonesClicked(): void {
    this.zones = $("#zones")[0].checked
  }

  zoneNamesClicked(): void {
    this.zoneNames = $("#zoneNames")[0].checked
  }

  sublocationsClicked(): void {
    this.sublocations = $("#sublocations")[0].checked
  }

  sublocationNamesClicked(): void {
    this.sublocationNames = $("#sublocationNames")[0].checked
  }

  private setLocateSettings(): void {
    if (this.serverObjectInstance.data && this.serverObjectInstance.data.length > 0) {
      for (const data of this.serverObjectInstance.data) {
        switch (data.property.property) {
          case "assets":
          case "people":
          case "perimeters":
          case "breadcrumbs":
          case "zones":
          case "zoneNames":
          case "sublocations":
          case "sublocationNames":
            this[data.property.property] = (data.value == "true");
            break;
        }
      }
    }
  }

  public updateSettingsLocate(): void {
    console.warn("updateSettingsLocate");
    this.spinner.show();

    if (this.serverObjectInstance.data && this.serverObjectInstance.data.length > 0) {
      for (const data of this.serverObjectInstance.data) {
        switch (data.property.property) {
          case "assets":
          case "people":
          case "perimeters":
          case "breadcrumbs":
          case "zones":
          case "zoneNames":
          case "sublocations":
          case "sublocationNames":
            data.value = (this[data.property.property]) ? "true" : "false";
            break;
        }
        data.object_value = this[data.property.property];
      }
    }

    this.serverObjectService.updateServerObjectInstance(this.serverObjectInstance)
      .then(
        response => {
          this.spinner.hide();
          console.log("update UserLockout Instance successful");
        },
        error => {
          this.spinner.hide();
          this.handleError(error);
        }
      );
  }

  handleError(error: any): void {
    console.error("handleError() - Error: " + error);
    if (error != null) {
      const response: Response = error;
      this.simpleSuccessErrorDialogComponent.showErrorDialog(ERROR_DIALOG_TITLE, response.text().toString());
    }
  }

}
